import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { CommonUtilsService } from '../../../shared/services/common-utils.service';
import { ConfigurationService } from 'src/app/configration/configuration.service';
import { UserSessionService } from 'src/app/user-profile/services/user-session.service';
import { ApiImportParam } from '../models/apiImportParams';
import { map } from 'rxjs/operators';
import { stringToBoolean } from 'src/app/shared/util/string-to-boolean';
import { ApiActionResult } from 'src/app/shared/models/api-action-result';

@Injectable({
  providedIn: 'root'
})
export class ApiImportParamsService {
  environment: any;
  endpoint: string;
  clientId: string;

  createHeaderObject() {
    const headerObj = this.commonUtils.getHeaderObject();
    return headerObj;
  }
  constructor(private http: HttpClient,
              private commonUtils: CommonUtilsService,
              private configurationservice: ConfigurationService,
              private userSessionService: UserSessionService) {
    this.environment = this.configurationservice.getEnvironmentVariables();
    this.endpoint = `${this.environment.musterkundeDevEndpoint}/api/ApiImportParams`;
    this.clientId = userSessionService.getClientId().toString();
  }

  // mapper needed because the booleans returned by API are recognized as strings
  mapApiImportParam(apiImportParam: ApiImportParam): ApiImportParam {
    apiImportParam.paramOptions.forEach(option => {
        option.selected = stringToBoolean(option.selected);
    });
    return apiImportParam;
  }

  getApiImportParams() {
    const url = this.endpoint;
    return this.http.get<ApiActionResult<ApiImportParam[]>>(url).pipe(
        map(response => response.Result.map(this.mapApiImportParam))
    );
  }

  saveApiImportParams(data: ApiImportParam[]) {
    const url = `${this.endpoint}`;
    return this.http.post<ApiActionResult<ApiImportParam[]>>(url, data).pipe(
        map(response => response.Result.map(this.mapApiImportParam))
    );
  }
}